import { Label } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { Col, DatePicker, Row, Select } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { MODULE_BENEFIT_ORDER } from '../../../constants/modules';
import { BENEFIT_ORDER } from '../../../services/util/globalConstant';
import BwgButton from '../../atoms/Button';
import SelectFolha from '../../atoms/SelectFolha';

function BenefitOrderListSearchFilters({ appliedFilters, onApplyFiltersClick, onClearFiltersClick }) {
  const [innerFilters, setFilters] = useState(appliedFilters);
  const isFiltersChanged = JSON.stringify(appliedFilters) !== JSON.stringify(innerFilters);

  useEffect(() => {
    setFilters({ ...appliedFilters });
  }, [appliedFilters]);

  const { companyId, competence, status, periodStatus } = innerFilters;

  const applyFilters = () => onApplyFiltersClick(innerFilters);

  const clearFilters = () => onClearFiltersClick();

  const shouldDisableMonth = (current) => {
    const currentMonth = moment().format('YYYY-MM');
    const datePickerMonth = current.format('YYYY-MM');
    return datePickerMonth > currentMonth;
  };

  return (
    <Row
      type="flex"
      gutter={[16, 16]}
    >
      <Col
        xs={24}
        sm={24}
        md={24}
        lg={12}
        xl={12}
        xxl={12}
      >
        <SelectFolha
          module={MODULE_BENEFIT_ORDER}
          folhaSelecionada={{ idFolha: companyId }}
          onChange={(value) => setFilters({ ...innerFilters, companies: value && [value.idFolha] })}
        />
      </Col>
      <Col
        xs={24}
        sm={24}
        md={12}
        lg={6}
        xl={6}
        xxl={6}
      >
        <Label label="Competência">
          <DatePicker.MonthPicker
            placeholder="MM/YYYY"
            format="MM/YYYY"
            picker="month"
            disabledDate={shouldDisableMonth}
            value={competence}
            onChange={(newValue) =>
              setFilters({
                ...innerFilters,
                competence: newValue,
              })
            }
          />
        </Label>
      </Col>
      <Col
        xs={24}
        sm={24}
        md={12}
        lg={6}
        xl={6}
        xxl={6}
      >
        <Label label="Status do Pedido">
          <Select
            value={status}
            allowClear
            placeholder="Todos"
            onChange={(newValue) =>
              setFilters({
                ...innerFilters,
                status: newValue,
              })
            }
            options={Object.keys(BENEFIT_ORDER.status).map((key) => ({
              value: key,
              label: BENEFIT_ORDER.status[key],
            }))}
          />
        </Label>
      </Col>
      <Col
        xs={24}
        sm={24}
        md={12}
        lg={6}
        xl={6}
        xxl={6}
      >
        <Label label="Status do Período">
          <Select
            value={periodStatus}
            allowClear
            placeholder="Todos"
            onChange={(newValue) =>
              setFilters({
                ...innerFilters,
                periodStatus: newValue,
              })
            }
            options={[
              {
                value: 'open',
                label: 'Aberto',
              },
              {
                value: 'close',
                label: 'Fechado',
              },
            ]}
          />
        </Label>
      </Col>
      <Col
        xs={24}
        sm={24}
        md={12}
        lg={6}
        xl={6}
        xxl={6}
      >
        <Label label="Status do Reabetura">
          <Select
            allowClear
            placeholder="Todos"
            onChange={(newValue) =>
              setFilters({
                ...innerFilters,
                reopeningStatus: newValue,
              })
            }
            options={Object.keys(BENEFIT_ORDER.reopeningStatus).map((key) => ({
              value: key,
              label: BENEFIT_ORDER.reopeningStatus[key],
            }))}
          />
        </Label>
      </Col>
      <Col
        xs={24}
        sm={24}
        md={24}
        lg={6}
        xl={6}
        xxl={6}
      >
        <Label label="&nbsp;">
          <BwgButton
            type="primary"
            disabled={!isFiltersChanged}
            onClick={() => applyFilters()}
          >
            Aplicar Filtros
          </BwgButton>
        </Label>
      </Col>
      <Col
        xs={24}
        sm={24}
        md={24}
        lg={6}
        xl={6}
        xxl={6}
      >
        <Label label="&nbsp;">
          <BwgButton
            type="link"
            onClick={clearFilters}
          >
            Limpar Filtros
          </BwgButton>
        </Label>
      </Col>
    </Row>
  );
}

const filtersShape = PropTypes.shape({
  folhas: PropTypes.shape(),
  competence: PropTypes.shape(),
  status: PropTypes.string,
  periodStatus: PropTypes.string,
});

BenefitOrderListSearchFilters.propTypes = {
  defaultFilters: filtersShape.isRequired,
  appliedFilters: filtersShape.isRequired,
  onApplyFiltersClick: PropTypes.func.isRequired,
  onClearFiltersClick: PropTypes.func.isRequired,
};

export default BenefitOrderListSearchFilters;
